import {showExportedJobTqo} from "../../../rpc/webrpc-client.gen.ts";
import {JsonEditor} from "json-edit-react";
import {createFileRoute} from "@tanstack/react-router";
import {Stack} from "@mui/joy";
import {ActionButton} from "../../../components/ActionButton.tsx";
import {useTranslation} from "react-i18next";
import {useRefreshableInfallibleQuery} from "../../../util/tqrefresh.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {useMothership} from "../../../tq/tqx.tsx";

interface ExportJobViewProps {
    jobId: string;
}

function ExportJobView({jobId}: ExportJobViewProps) {
    const mama = useMothership();
    const {data: exportJobString}
        = useRefreshableInfallibleQuery(showExportedJobTqo(mama, {jobId}));
    if (!exportJobString) {
        return null;
    }
    const exportJob = JSON.parse(exportJobString) as Record<string, unknown>;
    return <JsonEditor data={exportJob} restrictEdit={true}/>
}

function ExportJobPage() {
    const {id: jobId} = Route.useParams();
    const {t} = useTranslation();
    const mama = useMothership();
    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <Stack direction="column" sx={{alignItems: "center"}} spacing={1.8}>
                <ActionButton color="danger" variant="solid" sx={{fontSize: "xl", px: 4, py: 1.8}}
                              perform={() => mama.exportJob({jobId})}>
                    {t("exportButton")}
                </ActionButton>
                <ExportJobView jobId={jobId}/>
            </Stack>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/export/job/$id")({
    component: ExportJobPage,
});
